const validateURL = require('./validateUrl');

/**
 * Check if an URL is valid.
 *
 * @param {String} url the URL to validate.
 * @returns {boolean} true if the passed URL is valid, false otherwise
 */
module.exports = (url) => {
  return validateURL(url) && /^https:\/\/.+/.test(url);
};
